<ion-text class="ion-text-center" *transloco="let t">
  <span
    >{{
      content.length > 120 && !showMore
        ? (content | slice: 0:120) + '...'
        : content
    }}
    <a (click)="showMore = !showMore" *ngIf="content.length > 120">
      {{t(showMore ? 'common.readLess' : 'common.readMore')}}
    </a>
  </span>
</ion-text>
